import CustomTable from "../../../../components/common/Table/CustomTable";
import { columnInstallment } from "../constants";
import { Input } from "antd";
import { Link } from "react-router-dom";
import AppRoutePath from "../../../../router/AppRoutePath";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import httpclient from "../../../../components/httpclient";
import SwalToast from "../../../../components/helpers/SwalToast";
import {
  AuthorizationList,
  CanAccess,
} from "../../../../components/template/authorization/Authorization";
import ButtonInput from "../../../../components/common/Button/ButtonInput";

export default function LoanInstallment({
  data,
  loading,
  tablePagination,
  handleTableChange,
  handleEnter,
  handleOutletButtonClick,
}) {
  const history = useHistory();

  const handleEdit = (record) => {
    history.push({
      pathname: AppRoutePath.CAMPAIGN_INSTALLMENT_ADD,
      state: { data: record },
    });
  };

  return (
    <div style={{ marginTop: 24 }}>
      <div className="d-flex justify-content-between">
        <div className="mr-2">
          <div style={{ fontSize: 14, color: "#303030" }}>Nama Promo :</div>
          <Input
            onKeyDown={handleEnter && handleEnter("enter")}
            style={{
              marginTop: 8,
              width: "200px",
              borderRadius: 4,
              border: "0.75px solid #DCDCDC",
            }}
            name="name"
            placeholder="Nama Promo"
          />
        </div>
        <ButtonInput
          id={"outlet"}
          label={"Cabang/Outlet"}
          buttonText={"Nama Cabang"}
          onButtonClick={handleOutletButtonClick}
          variant={"outline-secondary"}
          width={"13%"}
        />
        <CanAccess
          role={AuthorizationList.create_regular_offer}
          yes={
            <div className="ml-auto d-flex align-items-center">
              <Link to={AppRoutePath.CAMPAIGN_INSTALLMENT_ADD}>
                <button className="ml-3 btn border-438EBC bgc-2C465C text-white font-weight-semi-bold">
                  + Tambah Reguler Offer
                </button>
              </Link>
            </div>
          }
        />
      </div>
      <div style={{ marginTop: 24 }}>
        <CustomTable
          columns={columnInstallment(handleEdit)}
          data={data}
          loading={loading}
          handleTableChange={handleTableChange}
          pagination={tablePagination}
          scrollX={2500}
        />
      </div>
    </div>
  );
}
